/* Aurae — interactions du thème */
(function () {
  'use strict';

  var A = window.Aurae || {};
  var routes = A.routes || {};

  function formatMoney(cents) {
    var format = A.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withSpaces = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        case 'amount_no_decimals': return parts[0];
        case 'amount_with_comma_separator': return withSpaces.replace(/ /g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return withSpaces.replace(/ /g, '.');
        case 'amount_with_space_separator': return withSpaces + ',' + parts[1];
        default: return parts[0] + ',' + parts[1];
      }
    });
  }

  /* ---------- Menu (hamburger qui déroule les liens sous le header) ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', function () {
      var open = menuPanel.hidden;
      menuPanel.hidden = !open;
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.classList.toggle('is-open', open);
    });
  }

  /* ---------- Comptes à rebours : une vraie date de fin, la même pour tous ---------- */
  /* La date est lue dans le fuseau de la boutique (Europe/Paris par défaut), pas dans celui
     du visiteur : tout le monde voit le même temps restant. Rien ne se relance : à la date
     de fin, le compteur disparaît. */
  function tzOffset(ts, tz) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
      return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - Math.floor(ts / 1000) * 1000;
    } catch (e) { return 0; }
  }
  function parseEnd(str, tz) {
    str = (str || '').trim();
    if (/(Z|[+-]\d{2}:?\d{2})$/i.test(str)) return Date.parse(str);
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/.exec(str);
    if (!m) return NaN;
    var t = m[4] != null;
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], t ? +m[4] : 23, t ? +m[5] : 59, t ? +(m[6] || 0) : 59);
    var off = tzOffset(wall, tz), ts = wall - off, off2 = tzOffset(ts, tz);
    return off2 === off ? ts : wall - off2;
  }
  var pad2 = function (x) { return (x < 10 ? '0' : '') + x; };
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = parseEnd(el.getAttribute('data-countdown'), el.getAttribute('data-countdown-tz') || 'Europe/Paris');
    var isBar = el.hasAttribute('data-countdown-bar');
    var text = el.querySelector('[data-countdown-value]');
    var label = el.querySelector('[data-cd-label]');
    var daysWrap = el.querySelector('[data-cd-days]');
    var set = function (k, v) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = v; };
    var timer;
    var tick = function () {
      var ms = end - Date.now();
      if (isNaN(ms) || ms <= 0) {
        el.hidden = true;
        if (isBar) document.documentElement.classList.remove('has-cdbar');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var txt = (d > 0 ? d + ' j ' : '') + pad2(h) + ' h ' + pad2(m) + ' min ' + pad2(sec) + ' s';
      if (text) text.textContent = txt;
      if (label) label.textContent = txt;
      if (daysWrap) daysWrap.hidden = d === 0;
      set('d', d); set('h', pad2(h)); set('m', pad2(m)); set('s', pad2(sec));
      el.hidden = false;
    };
    timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Tiroir panier ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.querySelector('.drawer-overlay');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    closeBtn && closeBtn.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    return fetch((routes.root_url || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content = document.getElementById('CartDrawerContent');
        var inner = tmp.querySelector('.shopify-section') || tmp;
        if (content) content.innerHTML = inner.innerHTML;
        var countEl = tmp.querySelector('[data-cart-count-value]');
        var count = countEl ? parseInt(countEl.textContent, 10) : 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openCart();
    }
    if (e.target.closest('[data-cart-close]')) closeCart();

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      qtyBtn.disabled = true;
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: qtyBtn.getAttribute('data-qty-change'), quantity: parseInt(qtyBtn.getAttribute('data-qty'), 10) })
      }).then(refreshCart).catch(function () { qtyBtn.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      if (menuPanel && !menuPanel.hidden) menuToggle.click();
    }
  });

  /* ---------- Fiche produit ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    if (!form) return;
    var variants = JSON.parse((form.querySelector('[data-variants]') || {}).textContent || '[]');
    var colorIndex = parseInt(section.getAttribute('data-color-index'), 10);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var errorEl = form.querySelector('[data-form-error]');
    var packItemsEl = form.querySelector('[data-pack-items]');
    var labelAdd = addLabel ? addLabel.textContent.trim() : 'Ajouter au panier';
    var sticky = document.querySelector('[data-sticky-buy]');

    var selected = [];
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    if (current) selected = current.options.slice();
    var pack = 1;
    var extraVariants = []; // variantes des articles 2 et 3 d'un pack

    /* --- Galerie / carrousel --- */
    var viewport = section.querySelector('[data-gallery-viewport]');
    var slides = viewport ? viewport.querySelectorAll('.pgallery__slide') : [];
    var activeIndex = 0;
    function setActive(i) {
      activeIndex = i;
      section.querySelectorAll('[data-gallery-dot]').forEach(function (d) { d.classList.toggle('is-active', +d.getAttribute('data-gallery-dot') === i); });
      section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-gallery-thumb') === i); });
    }
    function goTo(i) {
      if (!viewport || !slides.length) return;
      i = (i + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[i].offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    if (viewport) {
      var scrollTimer;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
          if (i !== activeIndex) setActive(i);
        }, 60);
      }, { passive: true });
    }
    section.querySelectorAll('[data-gallery-dot]').forEach(function (d) { d.addEventListener('click', function () { goTo(+d.getAttribute('data-gallery-dot')); }); });
    section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-gallery-thumb')); }); });
    var prev = section.querySelector('[data-gallery-prev]'), next = section.querySelector('[data-gallery-next]');
    prev && prev.addEventListener('click', function () { goTo(activeIndex - 1); });
    next && next.addEventListener('click', function () { goTo(activeIndex + 1); });
    function showMediaId(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) { goTo(i); return; }
      }
    }

    /* --- Variantes (pastilles de coloris / options) --- */
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === o; }); });
    }
    function packPrice() {
      var tile = form.querySelector('.pack[data-pack="' + pack + '"]');
      return tile ? parseInt(tile.getAttribute('data-pack-price'), 10) : (current ? current.price : 0);
    }
    function variantImage(v) {
      return v && v.featured_image ? v.featured_image.src : null;
    }
    function updateUI() {
      if (!current) return;
      idInput.value = current.id;
      current.options.forEach(function (val, i) {
        var lab = section.querySelector('[data-option-current="' + i + '"]');
        if (lab) lab.textContent = val;
      });
      section.querySelectorAll('[data-option-index]').forEach(function (b) {
        var i = +b.getAttribute('data-option-index');
        b.setAttribute('aria-checked', b.getAttribute('data-value') === current.options[i] ? 'true' : 'false');
      });
      var unitEl = form.querySelector('[data-pack-unit]');
      if (unitEl) unitEl.textContent = formatMoney(current.price);
      var tile1 = form.querySelector('.pack[data-pack="1"]');
      if (tile1) tile1.setAttribute('data-pack-price', current.price);

      var allAvailable = current.available && extraVariants.every(function (v) { return v && v.available; });
      addBtn.disabled = !allAvailable;
      addLabel.textContent = allAvailable ? labelAdd : 'Épuisé';

      if (sticky) {
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = formatMoney(packPrice());
        var sc = sticky.querySelector('[data-sticky-color]');
        if (sc && colorIndex >= 0) sc.textContent = current.options[colorIndex];
        var si = sticky.querySelector('.sticky-buy__media img');
        var src = variantImage(current);
        if (si && src) { si.src = src; si.removeAttribute('srcset'); }
      }
    }
    section.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[+btn.getAttribute('data-option-index')] = btn.getAttribute('data-value');
        var v = findVariant(selected);
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'Indisponible'; return; }
        current = v;
        if (v.featured_media) showMediaId(v.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        updateUI();
      });
    });

    /* --- Packs 1 / 2 / 3 --- */
    var colorValues = [];
    if (colorIndex >= 0) {
      variants.forEach(function (v) { if (colorValues.indexOf(v.options[colorIndex]) === -1) colorValues.push(v.options[colorIndex]); });
    }
    var multiColor = colorValues.length > 1;

    function buildPackItems() {
      extraVariants = [];
      if (!packItemsEl) return;
      packItemsEl.innerHTML = '';
      if (pack < 2 || !multiColor) { packItemsEl.hidden = true; return; }
      packItemsEl.hidden = false;
      var mainSwatches = section.querySelectorAll('.swatch');
      for (var n = 2; n <= pack; n++) {
        (function (n) {
          extraVariants[n - 2] = current;
          var row = document.createElement('div');
          row.className = 'pack-items__row';
          var label = document.createElement('p');
          label.className = 'pbuy__label';
          label.innerHTML = (n === 2 ? '2ᵉ' : '3ᵉ') + ' bracelet : <span></span>';
          label.querySelector('span').textContent = current.options[colorIndex];
          var group = document.createElement('div');
          group.className = 'swatches swatches--small';
          mainSwatches.forEach(function (sw) {
            var b = sw.cloneNode(true);
            b.removeAttribute('data-option-index');
            b.setAttribute('aria-checked', b.getAttribute('data-value') === current.options[colorIndex] ? 'true' : 'false');
            b.addEventListener('click', function () {
              var opts = current.options.slice();
              opts[colorIndex] = b.getAttribute('data-value');
              var v = findVariant(opts);
              if (!v) return;
              extraVariants[n - 2] = v;
              label.querySelector('span').textContent = b.getAttribute('data-value');
              group.querySelectorAll('.swatch').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
              updateUI();
            });
            group.appendChild(b);
          });
          row.appendChild(label);
          row.appendChild(group);
          packItemsEl.appendChild(row);
        })(n);
      }
    }
    function selectPack(n) {
      var tile = form.querySelector('.pack[data-pack="' + n + '"]');
      if (!tile) return;
      pack = n;
      form.querySelectorAll('.pack').forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      buildPackItems();
      updateUI();
    }
    form.querySelectorAll('.pack').forEach(function (t) {
      t.addEventListener('click', function () { selectPack(+t.getAttribute('data-pack')); });
    });
    var params = new URLSearchParams(window.location.search);
    var preset = parseInt(params.get('bundle') || params.get('qty') || '1', 10);
    if (preset > 1) selectPack(preset);

    /* --- Ajout au panier : tous les articles du pack d'un coup --- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      errorEl.textContent = '';
      var counts = {};
      counts[current.id] = (counts[current.id] || 0) + (multiColor ? 1 : pack);
      if (multiColor) extraVariants.forEach(function (v) { counts[v.id] = (counts[v.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-disabled', 'true');
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur, réessayez.');
          return refreshCart().then(openCart);
        })
        .catch(function (err) { errorEl.textContent = err.message; })
        .finally(function () {
          addBtn.classList.remove('is-loading');
          addBtn.removeAttribute('aria-disabled');
        });
    });

    /* --- Barre d'achat fixe : visible après ~520 px de scroll --- */
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      var onScroll = function () {
        var visible = window.scrollY > 520;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
        document.body.classList.toggle('has-sticky-buy', visible);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      stickyBtn && stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    updateUI();
  });
})();